import React, { useEffect, useState } from 'react';
import InstreamAdForm from './InstreamAdForm';
import { useParams } from 'react-router-dom';
import API from '../../../services/axiosInstance';
import { FormLoader, useFormLoader } from "../../common_modules/loader";

const CreateInstreamAd = () => {
  const [publisherName, setPublisherName] = useState("");
  const url = useParams();
  const accId = url?.id;
  // custom hook loader
  const { isLoading, startLoading, stopLoading } = useFormLoader();

  const getPublisherName = async () => {
    try {
      startLoading();
      // Each time request this api we get publisher name.
      const res = await API.get(`/publisher/instream/ad/setup/${0}/${accId}`);
      const data = res?.data?.data;
      setPublisherName(res?.data?.name);
    } catch (error) { } 
    finally {
      stopLoading();
    }
  }

  useEffect(() => {
    getPublisherName();
  }, []);

  return (
    <FormLoader isLoading={isLoading} text={"Loading..."}>
      <InstreamAdForm mode="add" publisherName={publisherName} />
    </FormLoader>
  )
}

export default CreateInstreamAd;